import { EmployeeContainerProps } from "@/components/Tasks/DragNDrop/DragNDropTasks"

export const STARTING_EMPLOYEE_CONTAINERS: EmployeeContainerProps[] = generateStartingEmployeeContainers()

function generateStartingEmployeeContainers(): EmployeeContainerProps[] {
    const employee_containers = Array.from({length: 5}, (_, index) => ({
        employee: {
            label: `Select a User ${index + 1}`,
            value: `Select a User ${index + 1}`,
            name: `Select a User ${index + 1}`,
            email: `Select a User ${index + 1}`
        },
        tasks: []
    }))

    return employee_containers
}

